const elementStyles = (element) => element.ownerDocument.defaultView.getComputedStyle(element);
const cache = {};
const toColor = (colorMix, element) => {
    if (cache[colorMix]) {
        return cache[colorMix];
    }
    const curColor = element.style.color;
    element.style.color = colorMix;
    const color = elementStyles(element).color;
    element.style.color = curColor;
    cache[colorMix] = color;
    return color;
};
const getProp = (element, prop) => {
    let value = elementStyles(element).getPropertyValue(prop);
    if (/^color-mix/i.test(value)) {
        value = toColor(value, element);
    }
    return value;
};
const loadTheme = (element) => {
    const primaryBg = getProp(element, '--kendo-chart-primary-bg');
    const primaryContrast = getProp(element, '--kendo-chart-primary-contrast');
    const normalTextColor = getProp(element, '--kendo-chart-text');
    const normalBackground = getProp(element, '--kendo-color-surface');
    return {
        shapeDefaults: {
            fill: {
                color: primaryBg
            },
            content: {
                color: primaryContrast
            },
            connectorDefaults: {
                fill: {
                    color: normalTextColor
                },
                stroke: {
                    color: primaryContrast
                },
                hover: {
                    fill: {
                        color: primaryContrast
                    },
                    stroke: {
                        color: normalTextColor
                    }
                }
            }
        },
        editable: {
            resize: {
                handles: {
                    stroke: {
                        color: normalTextColor
                    },
                    fill: {
                        color: normalBackground
                    },
                    hover: {
                        stroke: {
                            color: normalTextColor
                        },
                        fill: {
                            color: normalTextColor
                        }
                    }
                }
            }
        },
        selectable: {
            stroke: {
                color: normalTextColor
            }
        },
        connectionDefaults: {
            stroke: {
                color: normalTextColor
            },
            content: {
                color: normalTextColor
            },
            selection: {
                handles: {
                    fill: {
                        color: primaryContrast
                    },
                    stroke: {
                        color: normalTextColor
                    },
                    width: 8,
                    height: 8
                },
                stroke: {
                    color: normalTextColor
                }
            }
        }
    };
};

export { loadTheme };
